import AppPromotion from './AppPromotion';

export default AppPromotion;
